export const GET_AI_CONVERSATION = 'AI/GET_AI_CONVERSATION'
export const GET_AI_CONVERSATION_SUCCESS = 'AI/GET_AI_CONVERSATION_SUCCESS'
export const GET_AI_CONVERSATION_FAILED = 'AI/GET_AI_CONVERSATION_FAILED'
